import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { label, hint, error, id, className, ...rest },
  ref,
) {
  return (
    <label className="flex flex-col gap-1" htmlFor={id}>
      {label && (
        <span className="text-xs font-medium text-ink-3 uppercase tracking-wide">{label}</span>
      )}
      <input
        ref={ref}
        id={id}
        autoComplete="off"
        {...rest}
        className={cn(
          'kc-input',
          error && 'border-negative focus:border-negative focus:ring-negative-soft',
          className,
        )}
      />
      {error ? (
        <span className="text-xs text-negative">{error}</span>
      ) : hint ? (
        <span className="text-xs text-ink-3">{hint}</span>
      ) : null}
    </label>
  );
});
